import React from 'react';
import TextInput from './fields/TextInput';
import SubmitButton from './fields/SubmitButton';
import { Divider } from '@mui/material';
import SelectInput from './fields/SelectInput';

export default function FigureForm({ loading, currencyOptions }) {
  return (
    <>
      <SelectInput field="currency" label="Currency" options={currencyOptions} />
      <TextInput field="worth" label="Worth" />
      <Divider />
      <SubmitButton loading={loading}>Submit</SubmitButton>
    </>
  );
}
